import React from "react"

// The icons a tournament feedback theme may use (the API's fixed list, `icons` in GET /admin/tournament-feedback/catalog),
// copied from sportya-design `packages/sportya/src/icons.tsx` (SportyaIcon<Name>): CP does not consume the DS packages
// (decision (a), 2026-10-28, docs/design/tournament-feedback/README.md). Each icon keeps the DS SVG attributes and children
// exactly; `themeIcons.test.js` compares them with the DS source, so a DS change fails CP's tests until it is copied here.
const LINE = { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }

export const THEME_ICONS = {
  Calendar: { svg: { viewBox: "0 0 24 24", ...LINE, strokeWidth: 1.8 }, children: [
    ["rect", { x: "4", y: "5", width: "16", height: "15", rx: "2" }],
    ["path", { d: "M4 10h16M9 3v4M15 3v4" }],
  ] },
  Tennis: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M9.99935 18.3327C14.6018 18.3327 18.3327 14.6018 18.3327 9.99935C18.3327 5.39685 14.6018 1.66602 9.99935 1.66602C5.39685 1.66602 1.66602 5.39685 1.66602 9.99935C1.66602 14.6018 5.39685 18.3327 9.99935 18.3327Z", stroke: "currentColor", strokeWidth: 2 }],
    ["path", { d: "M9.99935 1.66602C9.95768 4.44435 9.27518 6.52852 7.95268 7.91768C6.6306 9.30768 4.53477 10.0023 1.66602 10.0027", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }],
    ["path", { d: "M18.3199 10.4187C15.6066 10.2325 13.5329 10.8129 12.0995 12.1587C10.6662 13.5045 9.96703 15.5629 10.0012 18.3333", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }],
  ] },
  Home: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M9.37 2.24a1 1 0 0 1 1.26 0l7 5.6a1 1 0 0 1 .37.78V17a1 1 0 0 1-1 1h-4.5v-5h-5v5H3a1 1 0 0 1-1-1V8.62a1 1 0 0 1 .37-.78l7-5.6Z", fill: "currentColor" }],
  ] },
  Trophy: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M5 2h10v2h3v2a4 4 0 0 1-3.4 3.95A5.5 5.5 0 0 1 11 13.4V15h2.5a1 1 0 0 1 1 1v1.5h-9V16a1 1 0 0 1 1-1H9v-1.6a5.5 5.5 0 0 1-3.6-3.45A4 4 0 0 1 2 6V4h3V2Zm-1 4a2 2 0 0 0 1.05 1.76A9 9 0 0 1 5 6H4Zm12 0h-1c0 .6-.02 1.2-.05 1.76A2 2 0 0 0 16 6Z", fill: "currentColor" }],
  ] },
  Player: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M10 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 9.5c3.9 0 7 1.9 7 4.5v2H3v-2c0-2.6 3.1-4.5 7-4.5Z", fill: "currentColor" }],
  ] },
  Users: { svg: { viewBox: "0 0 24 24", ...LINE, strokeWidth: 1.8 }, children: [
    ["circle", { cx: "9", cy: "8", r: "3.5" }],
    ["path", { d: "M2.5 20c0-3.6 2.9-5.5 6.5-5.5s6.5 1.9 6.5 5.5" }],
    ["path", { d: "M16 4.5a3.5 3.5 0 0 1 0 7M18 14.8c2.2.6 3.5 2.4 3.5 5.2" }],
  ] },
  CourtBooking: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M6 2v2h8V2h2v2h2v14H2V4h2V2h2Zm10 7H4v7h12V9Zm-6.9 5.6-2.6-2.6 1.1-1.1 1.5 1.5 3.3-3.3 1.1 1.1-4.4 4.4Z", fill: "currentColor" }],
  ] },
  Rankings: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M7.5 3h5a.5.5 0 0 1 .5.5V18h-6V3.5a.5.5 0 0 1 .5-.5ZM2 8.5A.5.5 0 0 1 2.5 8H6v10H2V8.5ZM14 6h3.5a.5.5 0 0 1 .5.5V18h-4V6Z", fill: "currentColor" }],
  ] },
  Bell: { svg: { viewBox: "0 0 20 20", fill: "none" }, children: [
    ["path", { d: "M10 2a1 1 0 0 1 1 1v.6a5.5 5.5 0 0 1 4.5 5.4v3.3l1.3 2.1a1 1 0 0 1-.85 1.6H4.05a1 1 0 0 1-.85-1.6l1.3-2.1V9A5.5 5.5 0 0 1 9 3.6V3a1 1 0 0 1 1-1Zm-2 15h4a2 2 0 0 1-4 0Z", fill: "currentColor" }],
  ] },
}
export const THEME_ICON_NAMES = Object.keys(THEME_ICONS)

// A theme's icon, decorative: the theme's title beside it names it. Nothing for a name outside the list.
export function ThemeIcon({ name, className = "" }) {
  const icon = Object.prototype.hasOwnProperty.call(THEME_ICONS, name) ? THEME_ICONS[name] : null
  if (!icon) return null
  return <svg {...icon.svg} aria-hidden="true" focusable="false" className={("feedback-theme-icon " + className).trim()}>
    {icon.children.map(([Tag, attributes], index) => <Tag key={index} {...attributes} />)}
  </svg>
}
